export default __webpack_public_path__ + "e4a9e0974fb588b01fe5e11edc7ad35b.png";